import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { usePanelResize } from '../../hooks/usePanelResize'
import type { AgentPanelSize } from './agentWidgetLayout'

// パネルの左の辺（横）、上の辺（縦）、左上の角（斜め）のつまみ。パネルは右下に固定なので、この3つで大きさを変える。
// 枠の端ぴったりを狙わなくてもつかめるよう、枠の外側に少しはみ出させる。角は辺より後に描いて上に重ねる。
// カーソルを当てると薄く色を付け、つかめる場所だと分かるようにする（見た目は仮。UI/UX の確認で決める）
export const AgentPanelResizeHandles = ({ onResize }: { onResize: (size: AgentPanelSize) => void }): ReactElement => {
  const { t } = useTranslation()
  const handlersOf = usePanelResize(onResize)
  const handles = [
    { edge: 'left', label: t(`幅を変える`), className: 'inset-y-0 -left-1 w-2 cursor-ew-resize' },
    { edge: 'top', label: t(`高さを変える`), className: 'inset-x-0 -top-1 h-2 cursor-ns-resize' },
    { edge: 'corner', label: t(`大きさを変える`), className: '-left-1 -top-1 size-4 cursor-nwse-resize' },
  ] as const

  return (
    <>
      {handles.map(({ edge, label, className }) => (
        <div
          key={edge}
          role="separator"
          aria-label={label}
          className={`absolute z-20 touch-none select-none rounded hover:bg-[#5991F6]/40 ${className}`}
          {...handlersOf(edge)}
        />
      ))}
    </>
  )
}
